export default [
  {
    path: '/users',
    name: 'Users',
    component: () => import('@/views/Users/Index.vue'),
    meta: {
      pageTitle: 'Kullanıcılar',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'APP_USERS',
      action: 'read',
    },
  },
  {
    path: '/users/add',
    name: 'UserAdd',
    component: () => import('@/views/Users/Add.vue'),
    meta: {
      pageTitle: 'Kullanıcılar',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/users',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'APP_USERS',
      action: 'read',
    },
  },
  {
    path: '/users/edit/:id',
    name: 'UserEdit',
    component: () => import('@/views/Users/Edit.vue'),
    meta: {
      pageTitle: 'Kullanıcılar',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/users',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'APP_USERS',
      action: 'read',
    },
  },
]
